import { useEffect, useMemo, useRef } from "react";
import { renderMarkdown } from "../markdown";

export function MarkdownRenderer({
  markdown,
  onCheckboxChange,
  savedCheckboxState,
}: {
  markdown: string;
  onCheckboxChange: (index: number, checked: boolean) => void;
  savedCheckboxState: Record<string, boolean>;
}) {
  const html = useMemo(() => renderMarkdown(markdown, savedCheckboxState), [markdown, savedCheckboxState]);
  const content = useRef<HTMLDivElement>(null);
  // The checkboxes come from innerHTML, not React, so React's onChange
  // never fires for them; a DOM listener on the container catches them.
  useEffect(() => {
    const element = content.current;
    if (!element) return;
    const onChange = (e: Event) => {
      const target = e.target as HTMLInputElement;
      const index = Number(target.dataset.checkbox ?? -1);
      if (target.type === "checkbox" && index >= 0) onCheckboxChange(index, target.checked);
    };
    element.addEventListener("change", onChange);
    return () => element.removeEventListener("change", onChange);
  }, [onCheckboxChange]);
  return <div ref={content} className="guide-content" dangerouslySetInnerHTML={{ __html: html }} />;
}
